import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { gridResourceDataSelector } from "./gridResourceDataSelector";
import {
  AllTypeResourceItem,
  AllTypeResourcesData,
} from "../../utils/types/resources";

export const gridResourcesFlatDataSelector = createDraftSafeSelector(
  [gridResourceDataSelector],
  (data): Record<string, AllTypeResourceItem> | undefined => {
    if (!data) {
      return;
    }

    return getChildResourcesRecursive(
      data?.resources as AllTypeResourcesData[],
    );
  },
);

const getChildResourcesRecursive = (data: AllTypeResourcesData[]) => {
  return data?.reduce(
    (acc, resource) => {
      acc[resource.id] = resource.resource;

      if (resource.child_resource?.resources) {
        acc = {
          ...acc,
          ...getChildResourcesRecursive(resource.child_resource?.resources),
        };
      }

      return acc;
    },
    {} as Record<string, AllTypeResourceItem>,
  );
};
